import type { Purpose } from "@/lib/mock-data";

const LEGEND: { purpose: Purpose; label: string; letter: string; cls: string }[] = [
  { purpose: "sale", label: "Sale", letter: "S", cls: "bg-sale" },
  { purpose: "rent", label: "Rent", letter: "R", cls: "bg-rent" },
  { purpose: "lease", label: "Lease", letter: "L", cls: "bg-lease" },
  { purpose: "parking", label: "Parking", letter: "PP", cls: "bg-parking" },
];

export function MapLegend({ active }: { active?: Purpose | "all" }) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-2xl bg-background/95 px-3 py-2 shadow-float backdrop-blur">
      {LEGEND.map((l) => {
        const dim = active && active !== "all" && active !== l.purpose;
        return (
          <span
            key={l.purpose}
            className={`flex items-center gap-1.5 text-[11px] font-medium text-brown-dark transition ${
              dim ? "opacity-35" : ""
            }`}
          >
            <span
              className={`flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[9px] font-bold text-white ${l.cls}`}
            >
              {l.letter}
            </span>
            {l.label}
          </span>
        );
      })}
    </div>
  );
}
